import React from 'react'
import {
  TwFootnote,
  TwLabel,
  TwWrapper
} from '@components/common/base/checkbox-new/containers'
import {TwRadioButton} from './containers'
import {RadiobuttonProps} from './types'

export const RadioButton = ({
  active,
  onClick,
  label,
  footnote,
  disabled,
  error,
  className
}: RadiobuttonProps) => (
  <TwWrapper
    className={className}
    $disabled={disabled}
    $withLabel={!!label}
    $withFootnote={!!footnote}
    onClick={active || disabled ? undefined : onClick}
  >
    <TwRadioButton $active={active} $disabled={disabled} $error={error} />
    {label && <TwLabel $disabled={disabled}>{label}</TwLabel>}
    {footnote && <TwFootnote $disabled={disabled}>{footnote}</TwFootnote>}
  </TwWrapper>
)
